import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchPtos', 'fetchSinglePto', 'fetchRejectedPtos', 'fetchPendingPtos']),
  ...buildCreateMutations(['createPto']),
  ...buildUpdateMutations(['updatePto', 'changeStatus']),
  ...buildDeleteMutations(['deletePto']),

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  openFormModal: (state) => {
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pto/mutations.js